export default {
  SHOPPING_CART: ["รถเข็น", "Shopping Cart"],
  DELIVERY_ADDRESS: ["ที่อยู่จัดส่ง", "Delivery Address"],
  PAYMENT: ["ชำระเงิน", "Payment"],
  SUMMARY: ["สรุปรายการ", "Summary"],
  ITEM_TOTAL: ["ยอดสินค้า", "Item Total"],
  DISCOUNT_FROM_PROMOTION: ["ส่วนลดจากโปรโมชั่น", "Discount From Promotion"],
  SUBTOTAL_AFTER_PROMOTION: ["ยอดสินค้าหลังส่วนลด", "Subtotal After Promotion"],
  COUPON_DISCOUNT: ["คูปองส่วนลด", "Coupon Discount"],
  SUBTOTAL_AFTER_COUPON: ["ยอดสินค้าหลังการใช้คูปอง", "Subtotal After Coupon"],
  REDEEM_POINTS: ["คะแนนสะสม", "Redeem Points"],
  SUBTOTAL_AFTER_REDEEM_POINTS: ["ยอดสินค้าหลังการใช้คะแนนสะสม", "Subtotal After Redeem Points"],
  DELIVERY_COST: ["ค่าจัดส่ง", "Delivery Cost"],
  TOTAL_COST: ["ยอดรวม", "Total Cost"],
  PRODUCT: ["สินค้า", "Product"],
  PRICE: ["ราคา", "Price"],
  QTY: ["จำนวน", "Qty"],
  TOTAL: ["รวม", "Total"],
  COUPON: ["คูปอง", "Coupon"],
  CHECKOUT: {
    SELECT_DELIVERY_ADDRESS: ["กำหนดที่อยู่จัดส่ง", "Select Delivery Address"],
    SELECT_PAYMENT_METHOD: ["เลือกวิธีการชำระเงิน", "Select Payment Method"],
    PROCEED_TO_PAYMENT: ["ดำเนินการชำระเงิน", "Proceed to Payment"],
    USE_PROMOTION_CODE: ["ใช้โค้ดส่วนลด", "Use Promotion Code"],
    LOGIN_TO_USE_COUPON: ["โปรดเข้าสู่ระบบ", "Login to Use Coupon"],
    USE_REDEEM_POINTS: ["ใช้คะแนนสะสม", "Use Redeem Points"],
    LOGIN_TO_USE_REDEEM_POINTS: ["โปรดเข้าสู่ระบบ", "Login to Use Redeem Points"],
    EDIT_REDEEM_POINTS: ["แก้ไขคะแนนสะสม", "Edit Redeem Points"],
    EXPAND_DETAIL: ["กดเพื่อย่อขยายดูรายละเอียด", "Expand Detail"],
    EMPTY_CART: ["ตอนนี้ตะกร้ายังว่างอยู่", "Empty Cart"],
    EMPTY_CART_DESCRIPTION: ["ก่อนจะเช็คเอาท์ได้ ต้องเพิ่มผลิตภัณฑ์เข้าตะกร้าก่อนนะคะ<br />คุณลูกค้าสามารถเลือกผลิตภัณฑ์ที่น่าสนใจได้จากหน้าร้านค้าของเราโดยคลิกด้านล่างค่า", "Before you can check out, you need to add products to your cart first.<br />You can select products of interest from our shop by clicking below."],
    GO_TO_SHOP: ["ไปยังหน้าร้าน", "Go to Shop"],
  }
}